 {
    "common": {
    "thisWeek": "Questa settimana",
    "lastWeek": "Settimana scorsa",
    "lastNumberOfDays": "Ultimi {numberOfDays} giorni",
    "thisMonth": "Questo mese"
    },
    "subAccounts": "Account secondari",
    "submitFeedback": "Invia feedback",
    "createSubAccount": "Crea un account secondario",
    "viewScheduleReports": "Visualizza i report programmati",
    "searchSubAccount": "Cerca per account secondario",
    "columns": "Colonne",
    "sortBy": "Ordina per",
    "selectColumns": "Seleziona colonne",
    "maxColumns": "Massimo 8 colonne a Dati",
    "applyColumns": "Applica colonne",
    "activeUsers": "Utenti attivi",
    "appointments": "Appuntamenti",
    "contacts": "Contatti",
    "emails": "Gmail",
    "textMessages": "Messaggi corporei",
    "calls": "Chiamate",
    "submissions": "Invii",
    "reviews": "Recensioni",
    "sitesCreated": "Siti creati",
    "name": "Nome",
    "formSubmissions": "Invio di moduli",
    "surveySubmissions": "Invii di sondaggi",
    "facebookFormSubmissions": "Invii di moduli di Facebook",
    "funnels": "Funnel",
    "websites": "Siti web",
    "forms": "Moduli",
    "surveys": "Sondaggi",
    "highestFirst": "Massimo prima",
    "lowestFirst": "Prima il più basso",
    "orderBy": "Ordina tramite",
    "noMoreLocations": "Non più Indirizzo trovato",
    "preparingReport": "Stiamo preparando il tuo report…",
    "preparingReportDesc": "Non chiudere o ricaricare questa finestra mentre l'esportazione è in corso.",
    "outOf": "Da",
    "subAccountsExported": "Account secondari esportati",
    "close": "Chiudi",
    "scheduledForDeletion": "Eliminazione Programmato",
    "readyToSell": "Pronto per la vendita",
    "closedWon": "Chiusa (aggiudicata)",
    "wpSaleSuccessful": "La vendita di WordPress è andata a buon fine",
    "wpNotSold": "WordPress non ancora venduto",
    "yxtSaleSuccessful": "La vendita Yext è andata a buon fine",
    "yxtNotSold": "Yext non ancora venduto",
    "saasSubInactive": "SaaS Abbonamento è Inattivo",
    "saasSubTrialing": "SaaS Abbonamento è in fase di prova",
    "saasSubActive": "SaaS Abbonamento è Dinamico",
    "emailRebillingActive": "Email Rifatturazione e Dinamico",
    "emailRebillingInactive": "Email Rifatturazione è Inattivo",
    "twilioRebillingActive": "Twilio Rifatturazione è Dinamico",
    "twilioRebillingInactive": "Twilio Rifatturazione è Inattivo",
    "wpRebillingActive": "La rifatturazione per WhatsApp è attiva",
    "wpRebillingInactive": "La rifatturazione per WhatsApp è inattiva",
    "saasModeActivated": "La modalità SaaS è Abilitato",
    "paymentPending": "Il Pagamento è in sospeso",
    "saasModeNotActivated": "La modalità SaaS non è Abilitato",
    "managedByLCPhone": "Gestisci tramite LC Telefono",
    "migrationToLCPhone": "In fase di migrazione a LC Telefono",
    "notManagedByLCPhone": "Non Gestisci tramite LC Telefono",
    "managedByLCEmail": "Gestisci tramite LeadConnector Email System",
    "notMangedByLCEmail": "Non gestisci tramite LeadConnector Email System",
    "remainingWalletBalance": "Saldo residuo nel portafoglio di questo luogo SaaS",
    "reports": "Report",
    "switchToSubAccount": "Passa all'account secondario",
    "manageClient": "Gestisci cliente",
    "subAccountDeletedIfChangedMind": "Questo account secondario verrà eliminato (momento di eliminazione: {time}); se hai cambiato idea",
    "subAccountDeletedInMinute": "Questo account secondario verrà eliminato entro il prossimo minuto",
    "changedMind": "Se hai dinamico la tua mente",
    "clickHere": "fai clic qui",
    "subAccountPaused": "Questo account secondario è in pausa. I tuoi clienti non possono accedere, ma l'agenzia sì. Per riprendere l'uso effettivo di questo account",
    "subAccountRestricted": "Questo account secondario è in pausa, in quanto è in attesa di approvazione.",
    "subAccountVerificationPending": "Questo account secondario è in pausa, in quanto è in attesa della verifica dell'email e del telefono da parte dell'amministratore dell'account secondario.",
    "subAccountDeclined": "Questo account secondario è in pausa, in quanto la richiesta di approvazione è stata rifiutata. Puoi comunque riprendere l'uso effettivo di questo account secondario da ",
    "here": "qui.",
    "reviewAndResume": "per controllare e riprendere l'uso di questo account secondario.",
    "incomingCalls": "Chiamate in entrata",
    "outgoingCalls": "Chiamate in uscita",
    "totalTalktime": "Tempo di conversazione Totale",
    "incomingEmails": "Gmailin entrata",
    "outgoingEmails": "Gmailin uscita",
    "incomingSms": "Messaggi Corpo in entrata",
    "outgoingSms": "Messaggi Corpo in uscita",
    "contactsCreated": "Contatti totali creati",
    "appointmentsBooked": "Totale appuntamenti prenotati",
    "totalFormSubmissions": "Totale invii modulo",
    "totalSurveySubmissions": "Totale invii Sondaggio",
    "totalFacebookFormSubmissions": "Totale degli invii di Modulo di Facebook",
    "incomingGMBMessages": "Messaggi GBP in entrata",
    "outgoingGMBMessages": "Messaggi GBP in uscita",
    "gmbMessages": "Messaggi GBP",
    "fbMessages": "Messaggi Facebook",
    "incomingFbMessages": "Messaggi Facebook in arrivo",
    "outgoingFbMessages": "Messaggi Facebook in uscita",
    "igMessages": "Messaggi Instagram",
    "incomingIgMessages": "Messaggi Instagram in arrivo",
    "outgoingIgMessages": "Messaggi Instagram in uscita",
    "totalReviews": "Recensioni Totale",
    "positiveReviews": "Recensioni positive",
    "negativeReviews": "Recensioni negative",
    "back": "Indietro",
    "selectDashboards": "Seleziona dashboard",
    "next": "Successivo",
    "backToSubAccounts": "Torna agli account secondari",
    "pauseSchedule": "Sospendi il programma",
    "resumeSchedule": "Riprendi il programma",
    "editSchedule": "Modifica la programmazione",
    "addSchedule": "Aggiungi programma",
    "selectReportToAdd": "Seleziona rapporti a Email in",
    "selectAll": "Seleziona ogni",
    "pauseScheduleConfirm": "Sei sicuro che tu vuoi sospendere il programma del report?",
    "resumeScheduleConfirm": "Sei sicuro che tu vuoi riprendi il report programma?",
    "tasks": "Attività",
    "conversations": "Conversazioni",
    "users": "Utente",
    "dealOverview": "Panoramica Accordo",
    "confirmAction": "Conferma azione",
    "yes": "Sì",
    "no": "No",
    "reportDetails": "Dettagli report",
    "reportCreatedOn": "Segnala Creato Attivo",
    "searchByEmail": "Cerca tramite Email",
    "lastActivity": "Ultima attività",
    "noRecords": "Nessun record trovato",
    "scheduleReport": "Programma report",
    "schedule": "programma",
    "save": "Salva",
    "emailSubject": "Oggetto Email",
    "frequency": "Frequenza",
    "daily": "Quotidiana",
    "weekly": "Settimanale",
    "monthly": "Mensile",
    "nextScheduleDate": "Data del Successivo programma",
    "startingOn": "A partire da Attivo",
    "timeOfDay": "Dati di giorno",
    "reportsToTimezone": "Il report verrà inviato secondo il fuso orario dell'account secondario",
    "selectRecipients": "Seleziona i destinatari",
    "invalidEmail": "Inserisci un indirizzo email valido.",
    "testEmail": "Email Test",
    "selectTestRecipients": "Seleziona Test i destinatari",
    "setupSubject": "Configura l'Argomento sopra per Test il rapporto",
    "sendTest": "Test di carica",
    "scheduleSimilarSchedules": "Programma un report simile per altri account secondari",
    "accountSummary": "Riepilogo account",
    "scheduleList": "Programma elenco",
    "subAccountName": "Nome dell'account secondario",
    "nextRunDate": "Data della prossima esecuzione",
    "reportSectionsAdded": "Sezioni del report aggiunte",
    "status": "Stato",
    "scheduleAction": "Programma azione",
    "cancel": "Annulla",
    "pleaseWait": "Caricamento in corso…",
    "confirm": "Conferma",
    "booked": "Prenotato",
    "confirmed": "Confermato",
    "showed": "Presentazione",
    "noShow": "Mancata presentazione",
    "cancelled": "Annullato",
    "unread": "Non letto",
    "engagement": "Fidanzamento",
    "reaction": "Reazione",
    "deliverySummary": "Riepilogo della consegna",
    "successfulDelivery": "Consegna riuscita",
    "opened": "Aperto",
    "clicked": "Cliccato",
    "replied": "Con risposta",
    "unsubscribed": "Iscrizione annullata",
    "complained": "Lamentato",
    "failed": "Non riuscito",
    "bounced": "Respinto",
    "open": "Aperta",
    "won": "Vinta",
    "abandoned": "Abbandonata",
    "lost": "Persa",
    "sent": "Inviato",
    "eject": "Espelli",
    "delivered": "Consegnato",
    "faceBookLeadForm": "Modulo per lead di Facebook",
    "overdue": "Scaduto",
    "reviewsReceived": "Recensioni Ricevuto",
    "formBuilders": "Builder di moduli",
    "switchToSaaS": "Passa a SaaS",
    "numberOfContacts": "Contatti totali",
    "numberOfAppointments": "Totale degli appuntamenti",
    "outreach": "Sensibilizzazione",
    "notSubAccountUser": "Non è un utente di un account secondario",
    "searchSubAccName": "Cerca per nome dell'account secondario",
    "recipients": "Destinatari",
    "scheduleCreated": "Il programma di report via email è stato creato per ",
    "scheduleUpdated": "Il programma di report via email è stato aggiornato per ",
    "scheduleNotCreated": "Non è stato possibile creare il programma di report via email per",
    "scheduleNotUpdated": "Non è stato possibile aggiornare il programma di report via email per",
    "total": "Totale",
    "inbound": "In entrata",
    "outbound": "In uscita",
    "totalEmails": "Email totali",
    "inboundEmails": "Email in entrata",
    "outboundEmails": "Email in uscita",
    "totalTextMessages": "Totale messaggi di testo",
    "inboundTextMessages": "Messaggi di testo in entrata",
    "outboundTextMessages": "Messaggi di testo in uscita",
    "totalCalls": "Chiamate totali",
    "inboundCalls": "Chiamate in entrata",
    "outboundCalls": "Chiamate in uscita",
    "faceBookLeadFormSubmissions": "Invii di moduli compilati da lead di Facebook",
    "inboundGMBMessages": "Messaggi GBP in entrata",
    "outboundGMBMessages": "Messaggi GBP in uscita",
    "totalIgMessages": "Totale messaggi Instagram",
    "inboundIgMessages": "Messaggi Instagram in entrata",
    "outboundIgMessages": "Messaggi Instagram in uscita",
    "totalfbMessages": "Totale messaggi Facebook",
    "inboundfbMessages": "Messaggi Facebook in entrata",
    "outboundfbMessages": "Messaggi Facebook in uscita",
    "sitesCreatedFunnels": "Siti creati - funnel",
    "sitesCreatedActiveFunnels": "Siti creati - Funnel attivi",
    "sitesCreatedWebsites": "Siti creati - siti web",
    "sitesCreatedActiveWebsites": "Siti creati - Siti web attivi",
    "sitesCreatedForms": "Siti creati - moduli",
    "sitesCreatedActiveForms": "Siti creati - moduli attivi",
    "sitesCreatedSurveys": "Siti creati - Sondaggi",
    "sitesCreatedActiveSurveys": "Siti creati - sondaggi attivi",
    "googleReviews": "Recensioni Google",
    "facebookReviews": "Recensioni di Facebook",
    "inboundCallDuration": "Durata delle chiamate in entrata (ore)",
    "outboundCallDuration": "Durata delle chiamate in uscita (ore)",
    "pleaseSelect": "Seleziona",
    "subAccountIsDeleted": "Questo account secondario è stato eliminato",
    "subAccountIsPaused": "Questo account secondario è stato messo in pausa",
    "success": "Successo",
    "error": "Errore",
    "testEmailSent": "Email Test inviato",
    "testEmailNotSent": "Email Test non ha potuto essere inviato",
    "reviewRequest": "Rivedi le richieste",
    "pendingTransferDescription": "Altre agenzie hanno richiesto di trasferirti degli account secondari.",
    "pendingTransferHeading": "Hai delle richieste di trasferimento di account secondari in sospeso.",
    "subAccountTransfer": "Trasferimenti di account secondari",
    "manageSubAccTransfer": "Gestisci le tue richieste di trasferimento di account secondari",
    "subAccRequest": "Richieste {tabName} di account secondari",
    "receive": "Eredita",
    "send": "Invia",
    "release": "Versione",
    "requests": "{count} richieste",
    "subAccLimit": "Limite di utilizzo degli account secondari raggiunto.",
    "subAccPlanLimit": "Hai utilizzato 3/3 degli account secondari consentiti dal tuo piano attuale.",
    "upgradeTime": "È ora di un passare a un piano di livello superiore!",
    "upgradeHigher": "Per accettare il trasferimento dell'account secondario, passa a un piano di livello superiore.",
    "browse": "Esplora i piani",
    "pendingTransferTitle": "Per questo account secondario c'è già una richiesta di trasferimento in sospeso.",
    "unableTransfer": "Impossibile trasferire l'account secondario a questa agenzia.",
    "unableEjectCancel": "Impossibile annullare la richiesta di espulsione dell'account secondario.",
    "EjectErrorDetails": "La richiesta di espulsione dell'account secondario non può essere annullata.",
    "hippaErrorDescription": "Questo account secondario è abilitato per la conformità alla normativa HIPAA e non può essere trasferito a un'agenzia non HIPAA.",
    "pendingTransferErrorDescription": "Prima di procedere con la creazione di una nuova richiesta di trasferimento per questo account secondario, devi annullare quella già esistente.",
    "receivingAgency": "Agenzia ricevente",
    "releasingAgency": "Agenzia di origine",
    "noOfContacts": "Contatti totali",
    "requestedDate": "Data richiesta",
    "action": "Azione",
    "cancelTransfer": "Annulla trasferimento",
    "decline": "Rifiuta",
    "cancelTransferRequest": "Vuoi annullare la richiesta di trasferimento dell'account secondario?",
    "cancelEjectRequest": "Vuoi annullare la richiesta di espulsione dell'account secondario?",
    "cancelRequestDescription": "L'agenzia ricevente non vedrà più questa richiesta di trasferimento e l'account secondario {name} non verrà trasferito.",
    "cancelEjectRequestDescription": "L'utente selezionato non potrà più creare una nuova agenzia dall'account secondario {name}.",
    "declineRequest": "Vuoi rifiutare la richiesta di trasferimento dell'account secondario?",
    "declineRequestDescription": "La richiesta verrà rifiutata e l'account secondario {name} non verrà trasferito alla tua agenzia.",
    "approveTransfer": "Vuoi approvare il trasferimento dell'account secondario alla tua agenzia?",
    "approveTransferDescription": "L'account secondario {name} verrà trasferito alla tua agenzia.",
    "transferNow": "Trasferisci ora",
    "cancelNow": "Annulla ora",
    "transferErrorDetails": "Questo account secondario non può essere trasferito.",
    "cancelRequest": "Annulla richiesta",
    "received": "Ricevuto",
    "approve": "Approva",
    "goBack": "Torna indietro",
    "done": "Fatto",
    "subAccountTransferred": "L'account secondario è stato trasferito correttamente!",
    "subAccountTransferDescription": "Anche se l'account secondario è stato trasferito, per alcune risorse come utenti, numeri di telefono, account Mailgun e listing su Yext, potrebbero volerci altri 10-15 minuti prima che siano visualizzate nella destinazione.",
    "activeSubscriptionsAlert": "Il Luogo ha Dinamico Abbonamento. Annullare ogni Abbonamento Prima trasferimento a freddo the Luogo. Elenco di Dinamico Abbonamento: {subscriptions}",
    "isSaasEnabled": "SaaS abilitato",
    "typeToSearch": "Digita per cercare",
    "dateAdded": "Giorno di aggiunta",
    "emailEngagement": "Interazioni email",
    "emailReaction": "Reazione email",
    "emailDeliverySummary": "Riepilogo consegna email",
    "facebook": "Facebook",
    "sms": "SMS",
    "instagram": "Instagram",
    "accountSummarySubAccount": "Riepilogo account - {subAccountName}",
    "test": "Test",
    "scheduleExists": "Il programma esiste",
    "aToZ": "Dalla A alla Z",
    "zToA": "Z - A",
    "onlyAdminUsersCanAddNewSubAccounts": "Solo gli utenti con ruolo di amministratori possono aggiungere nuovi account secondari.",
    "locationName": "Nome del luogo",
    "transferCompleted": "La richiesta di trasferimento per questo luogo è già stata elaborata. Aggiorna la pagina.",
    "unauthorizedTransfer": "Tu non sei autorizzato a compiere questa Azione. Solo i titolari di Agenzia possono eseguire questa Azione.",
    "bulkLocationTransfer": "Trasferimento in blocco di account secondari",
    "singleRequest": "Richiesta singola",
    "bulkRequest": "Richiesta in blocco",
    "backToLocationTransfer": "Torna al trasferimento del luogo",
    "initiateBulkTransfer": "Avvia il trasferimento in blocco degli account secondari",
    "initiateBulkTransferDescription": "Seleziona gli account secondari che desideri trasferire o inserisci i loro ID separati da virgole.",
    "subAccountId": "ID account secondario",
    "selectFromList": "Seleziona dall'elenco",
    "addManually": "Aggiungi manualmente",
    "accountsSelected": "Selezionati: {count}",
    "selectAllSubAccounts": "Seleziona ogni",
    "removeAll": "Rimuovi tutto",
    "addManualLocations": "Aggiungi gli ID dei luoghi separati da virgole",
    "manualAllLocationIds": "I Luogo IDs del sub-account desiderano Trasferisci, Separato tramite virgole.",
    "enterLocationIds": "Inserisca gli ID dei luoghi",
    "selectSubAccounts": "Seleziona gli account secondari e trasferiscili a un'agenzia esistente",
    "subAccountTransferWarning": "ogni risorsa dell'account secondario e utente riceverà Scarica.",
    "proceed": "Procedi",
    "bulkRequestSubmitted": "Richiesta di trasferimento in blocco inviata",
    "bulkRequestSubmittedDescription": "Ogni account secondario verrà trasferito una volta che l'agenzia ricevente avrà accettato la richiesta di trasferimento. Puoi monitorare lo stato della richiesta sulla pagina ❝{pagename}❞. (A condizione che i criteri di idoneità siano soddisfatti)",
    "bulkTransferRequestFailed": "Richiesta di trasferimento in blocco non andata a buon fine",
    "errorLocations": "Account secondari con errori",
    "viewDetails": "Visualizza i dettagli",
    "somethingWrong": "Qualcosa è andato storto. Riprova.",
    "confirmBulkRequest": "Vuoi confermare la richiesta di trasferimento in blocco?",
    "bulkTransferAccounts": "Vuoi procedere con il trasferimento in blocco degli account secondari selezionati ({count})?",
    "confirmDetails": "Conferma i dettagli prima di procedere con il trasferimento.",
    "transferConsent": "Ho letto e compreso la guida di cui sopra e consenso a ogni limitazione.",
    "transferInfo": "Il trasferimento dell'account secondario è subordinato all'accettazione da parte dell'agenzia ricevente sul proprio account.",
    "receivingRelNo": "Numero di relazione dell'agenzia ricevente",
    "enterRelNo": "Inserisci il numero di relazione",
    "transferConfirmation": "Al completamento di questa Azione, l'In blocco Trasferisci Richieste sarà inviato alla Ricevuto Agenzia ({ relNo }). Ogni account secondario che hai selezionato sarà Scarica una volta che Ricevuto Agenzia lo accetta. Si prega di notare che questa Azione è irreversibile per ogni account secondario incluso in Trasferisci.",
    "confirmPassword": "Conferma tramite digitando password sotto",
    "enterPassword": "Inserisci la password",
    "requestTransfer": "Richiedi il trasferimento",
    "confirmTransfer": "Conferma il trasferimento",
    "notNow": "Non adesso",
    "invalidRelNo": "Numero di relazione non valido",
    "invalidPassword": "password non valida .",
    "searchSubAccounts": "Cerca account secondari",
    "searchSubAccountsId": "Cerca ID account secondario",
    "takeAction": "Agisci",
    "sub_account_details": "Dettagli dell'account secondario",
    "no_of_contacts": "Contatti totali",
    "transfer_status": "Stato del trasferimento",
    "error_info": "Informazioni sull'errore",
    "bulk_transfer_status": "Stato del trasferimento in blocco degli account secondari",
    "pending": "In sospeso",
    "processed": "Elaborato",
    "reject_all": "Rifiuta tutto",
    "accept_all": "Accetta tutto",
    "cancel_all": "Annulla tutto",
    "clearAll": "Rimuovi tutto",
    "refresh": "Aggiorna",
    "rejected": "Negato",
    "decline_transfer": "Rifiuta il trasferimento",
    "decline_bulk_transfer": "Vuoi rifiutare la richiesta di trasferimento dell'account secondario?",
    "decline_bulk_transfer_description": "La richiesta verrà rifiutata e {length} account secondari non verranno trasferiti alla tua agenzia.",
    "accept_bulk_transfer": "Vuoi accettare la richiesta di trasferimento dell'account secondario?",
    "accept_bulk_transfer_description": "La richiesta verrà accettata e {length} account secondari saranno trasferiti alla tua agenzia.",
    "cancel_bulk_transfer": "Vuoi annullare il trasferimento in blocco?",
    "cancel_bulk_transfer_description": "Vuoi davvero annullare questo trasferimento in blocco di {length} account secondari a \"{name}\"?",
    "consent_sub_account_transfer": "Leggi e acconsenti a {link}",
    "sub_account_transfer_guidelines": "Linee guida per il trasferimento degli account secondari",
    "valid_rel": "Inserisci numero di relazione valido",
    "something_went_wrong": "Qualcosa è andato storto. Riprova.",
    "export": "Esporta",
    "export_success": "I dati che Tu ha richiesto sono in fase di elaborazione. Tu eredita Email con i dati in alcuni Dati.",
    "export_failed": "I dati Tu richiesti non hanno potuto essere trattati. Riprova più tardi.",
    "selectAllError": "Puoi selezionare solo 1.000 account secondari per volta.",
    "max1000": "(Max 1.000)",
    "subAccountCount": "Numero di account secondari",
    "whatsapp": "WhatsApp",
    "scheduleBulkPauseConfirm": "Tu sei sicuro che tu desideri Sospendi {count} rapporti?",
    "scheduleBulkResumeConfirm": "Tu sei sicuro che tu voglia riprendi {count} rapporti?",
    "resume": "Riprendi",
    "pause": "Sospendi",
    "resumeSelected": "Riprendi selezionato",
    "pauseSelected": "Sospendi selezionati",
    "bulkActions": "Bulk actions",
    "xReportsSelected": "{count} report selezionati",
    "selectAllXReports": "Selezioni tutti i report ({count})",
    "scheduleStatus": "Stato del programma",
    "scheduleSearchPlaceholder": "Cerca per email o nome del luogo",
    "subAccountsPerPage": "Account secondari per pagina",
    "previous": "Precedente",
    "scheduleBulkAction": "Pianifica azione in blocco",
    "all": "Tutto",
    "active": "Attivo",
    "paused": "Sospeso",
    "scheduleUpdatedSuccessfully": "Aggiornamento del programma con successo",
    "saveChanges": "Salva modifiche",
    "pauseSchedulesTitle": "Rapporti di Sospendi Attivo Programmato",
    "pauseSchedulesDescription": "fai clic ai report di Sospendi ora Attivo.",
    "pauseSchedulesAlert": "Questo influirà solo sugli Account che sono ora Dinamico.",
    "pauseAllSchedulesBtnText": "Metti in pausa tutti i report programmati",
    "autoScheduleTitle": "Pianificazione automatica per i nuovi account",
    "autoScheduleLabel": "Crea automaticamente report programmati quando viene aggiunto un nuovo account secondario.",
    "autoScheduleAlert": "Disabilita questo Se Tu desideri configurare manualmente per il nuovo Account.",
    "autoScheduleEnabledForNewAccounts": "Autoprogramma abilitato per Nuovo Account",
    "autoScheduleDisabledForNewAccounts": "Auto-Programma Disabilitato per Nuovo Account",
    "deleted": "Eliminato",
    "locationPaused": "Luogo in pausa",
    "scheduleSettingsModalTitle": "programma report Impostazioni",
    "selectAllSchedules": "Seleziona ogni programma",
    "selectScheduleForLocation": "Seleziona il programma per {location}",
    "openSettings": "Apri Impostazioni",
    "resumeScheduleForLocation": "Riprendi il programma per {location}",
    "pauseScheduleForLocation": "Sospendi il programma per {location}",
    "actions": "Azioni",
    "deselectAll": "Deseleziona ogni",
    "scheduleBulkActionResumeSuccess": "Attivazione in blocco in corso — Attesa Disabilitato Attivo Nuovo attività",
    "scheduleBulkActionPauseSuccess": "Metti in pausa i report; attendi prima di intraprendere ulteriori azioni",
    "bulkActionCreationError": "È in corso un'altra azione in blocco. Riprova tra un attimo.",
    "bulkActionInProgress": "Azione In blocco già in corso",
    "scheduledReports": "Report Programmato",
    "scheduleBulkActionCompleted": "In blocco Azione Fatto con successo",
    "pauseAllSchedulesModalTitle": "Vuoi mettere in pausa i report?",
    "pauseAllSchedulesModalText": "Questo metterà in pausa tutti i report pianificati attivi negli account secondari.",
    "addLocationIdsPlaceholder": "Aggiungi gli ID dei luoghi che desideri trasferire...",
    "helloWorld": {
      "count": "Il numero è {count}",
      "editIntro": "Modifica",
      "editAction": "Per testare HMR",
      "checkOut": "Dai un'occhiata",
      "officialStarter": ", lo starter ufficiale di Vue + Vite",
      "install": "Installa",
      "installDescription": "Nel tuo IDE per una migliore DX",
      "learnMore": "Fai clic sui loghi Vite e Vue per saperne di più"
    },
    "home": {
      "testMessage": "Ciao! Questa è la homepage di test!"
    },
    "reports": {
      "incoming": "In entrata",
      "outgoing": "In uscita",
      "duration": "Durata",
      "contactsCount": "Totale contatti",
      "appointmentsCount": "Totale degli appuntamenti",
      "formSubmissions": "Invii di moduli",
      "surveySubmissions": "Invii di sondaggi",
      "facebookFormSubmissions": "Invii di moduli di Facebook",
      "funnels": "Funnel",
      "websites": "Siti web",
      "forms": "Moduli",
      "surveys": "Sondaggi",
      "gbpMessages": "Messaggi GBP",
      "facebookMessages": "Messaggi Facebook",
      "instagramMessages": "Messaggi Instagram",
      "reviews": "Recensioni",
      "positives": "Aspetti positivi",
      "negatives": "Aspetti negativi"
    },
    "timeOptions": {
      "00": "00:00",
      "01": "01:00",
      "02": "02:00",
      "03": "03:00",
      "04": "04:00",
      "05": "05:00",
      "06": "06:00",
      "07": "07:00",
      "08": "08:00",
      "09": "09:00",
      "10": "10:00",
      "11": "11:00",
      "12": "12:00",
      "13": "13:00",
      "14": "14:00",
      "15": "15:00",
      "16": "16:00",
      "17": "17:00",
      "18": "18:00",
      "19": "19:00",
      "20": "20:00",
      "21": "21:00",
      "22": "22:00",
      "23": "23:00"
    },
    "transferStatus": {
      "pending": "In sospeso",
      "processed": "Elaborato",
      "canceled": "Annullato",
      "cancelled": "Annullato",
      "completed": "Completato",
      "rejected": "Rifiutato",
      "failed": "Non riuscito",
      "payment_pending": "Pagamento in sospeso"
    }
    }
